/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, signal, Output, EventEmitter, input, effect } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { DesyAngularModule } from 'desy-angular';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { getError } from '@/app/utils/form-errors';
import { AiSystemDeployment, Step2Deployment } from '@/app/interfaces/aiSystemDeployment';
import { setupConditionalRequiredValidation, setupRequiredValidationBySignal } from '../helpers/validation.helper';
import { binaryOptions } from '../helpers/binary-options.interface';

@Component({
  selector: 'app-deploy-system-of-ia-step-2',
  templateUrl: './deploy-system-of-ia-step-2.component.html',
  styleUrls: ['./deploy-system-of-ia-step-2.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule,
    ButtonsComponent,
    DesyAngularModule,
    DatePickerModule,
    SelectButtonModule,
    MultiSelectModule,
  ],
  providers: [ConfirmationService],
})
export class DeploySystemOfIaStep2Component {
  @Output() stepCompleted = new EventEmitter<Step2Deployment>();
  @Output() goToPreviousStep = new EventEmitter<Step2Deployment>();

  existingData = input<Partial<AiSystemDeployment>>();

  form: FormGroup;
  getError = getError;

  binaryOptions = binaryOptions;

  formSubmitted = signal(false);
  highRiskFieldsRequired = signal(false);
  userInfoRequired = signal(false);

  constructor(
    private fb: FormBuilder,
    private router: Router
  ) {
    this.form = this.fb.group({
      usageInstructions: [null, Validators.maxLength(200)],
      humanSupervision: null,
      inputDataQuality: [null, Validators.maxLength(200)],
      qualityMonitoring: [null, Validators.maxLength(500)],
      logRetention: [null, Validators.maxLength(200)],
      fria: [null, Validators.maxLength(200)],
      dpia: [null, Validators.maxLength(200)],
      naturalPersonInteraction: [null, Validators.required],
      contentGeneration: [null, Validators.required],
      biometricsEmotions: [null, Validators.required],
      publicInterestText: [null, Validators.required],
      userInformation: [null, Validators.maxLength(500)],
    });

    setupConditionalRequiredValidation(
      this.form,
      this.userInfoRequired,
      ['userInformation'],
      ['naturalPersonInteraction', 'contentGeneration', 'biometricsEmotions', 'publicInterestText']
    );

    setupRequiredValidationBySignal(this.form, this.highRiskFieldsRequired, [
      'usageInstructions',
      'humanSupervision',
      'inputDataQuality',
      'qualityMonitoring',
      'logRetention',
      'fria',
      'dpia',
    ]);

    effect(() => {
      const data = this.existingData();
      if (data) {
        this.form.patchValue(data);
      }
      const isHighRisk = data.systemClassification === 'alto';
      this.highRiskFieldsRequired.set(isHighRisk);
    });
  }

  async onSave() {
    const formData = this.form.value;
    this.stepCompleted.emit(formData);
  }

  backPage(): void {
    const formData = this.form.value;
    this.goToPreviousStep.emit(formData);
  }

  cancel(): void {
    this.router.navigate([`/catalogo-ia/sistemas-de-ia/listado-sistemas`]);
  }

  confirm() {
    this.formSubmitted.set(true);
    this.onSave();
  }
}
